export const SUPPORTED_LANGUAGES = ["de", "en"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export const DEFAULT_LANGUAGE: SupportedLanguage = "de";

export const routeLanguageMap: Record<string, string> = {
  "/": "/en/",
  "/pharma-transport": "/en/pharma-transport",
  "/catering-events": "/en/catering-events",
  "/lebensmittel-transport": "/en/food-transport",
  "/mobile-kuehlung": "/en/mobile-cooling",
  "/transporter-mieten": "/en/van-rental",
  "/kleinbus-mieten-frankfurt": "/en/minibus-rental-frankfurt",
  "/kuehltransport-mit-fahrer": "/en/refrigerated-transport-with-driver",
  "/ueber-uns": "/en/about-us",
  "/standorte": "/en/locations",
  "/eis-transport": "/en/ice-transport",
  "/fisch-transport": "/en/fish-transport",
  "/fleisch-doener-transport": "/en/meat-doner-transport",
  "/kuehlwagen-kaufen": "/en/refrigerated-vans-for-sale",
  "/kuehlwagen-mieten": "/en/refrigerated-van-hire",
  "/haccp-leitfaden": "/en/haccp-guide",
  "/vertrauen-sicherheit": "/en/trust-security",
  "/impressum": "/en/imprint",
  "/datenschutz": "/en/privacy",
  "/agb": "/en/terms",
  "/qrcode": "/en/qrcode",
  "/unsubscribe": "/en/unsubscribe",
};

export const englishToGermanMap: Record<string, string> = Object.fromEntries(
  Object.entries(routeLanguageMap).map(([de, en]) => [en, de])
);

export function getLanguageFromPath(path: string): SupportedLanguage {
  if (path === "/en" || path.startsWith("/en/")) return "en";
  return "de";
}

/** Dynamische Routen mit Parameter (z. B. Stadt-Landingpages) */
const dynamicRoutePrefixes: Array<{ de: string; en: string }> = [
  { de: "/kuehltransporter-mieten/", en: "/en/refrigerated-van-rental/" },
];

export function getGermanPath(englishPath: string): string {
  const exact = englishToGermanMap[englishPath];
  if (exact) return exact;
  for (const { de, en } of dynamicRoutePrefixes) {
    if (englishPath.startsWith(en)) return de + englishPath.slice(en.length);
  }
  return "/";
}

export function getEnglishPath(germanPath: string): string {
  const exact = routeLanguageMap[germanPath];
  if (exact) return exact;
  for (const { de, en } of dynamicRoutePrefixes) {
    if (germanPath.startsWith(de)) return en + germanPath.slice(de.length);
  }
  return "/en/";
}
